import { PaletteMode } from '@mui/material';

/**
 * Brand color for a social platform.
 *
 * Use the object form when the light-mode brand color (typically black, as with X,
 * TikTok and Dailymotion) has too little contrast against dark surfaces.
 */
export type SocialPlatformColor = string | { light: string; dark: string };

/** Picks the brand color variant matching the active palette mode. */
export function resolvePlatformColor(color: SocialPlatformColor, mode: PaletteMode) {
  return typeof color === 'string' ? color : color[mode];
}
